import { render, staticRenderFns } from "./KDS.vue?vue&type=template&id=a376d762&"
import script from "./KDS.vue?vue&type=script&lang=js&"
export * from "./KDS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports